import { render, staticRenderFns } from "./DocumentTypeList.vue?vue&type=template&id=ba92d810&scoped=true&"
import script from "./DocumentTypeList.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypeList.vue?vue&type=style&index=0&id=ba92d810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba92d810",
  null
  
)

export default component.exports